import { lazy } from 'react';

import { AuthRoute } from 'modules/auth/routes/auth-route';

const Label = lazy(() => import('./label'));

export default {
  routes: [<AuthRoute key="/label/:labelId" path="/label/:labelId?" render={() => <Label />} />],
};
